import { types, actions } from './requests'
export const CHANGEPASSWORD_TYPES = {
    ...types('CHANGEPASSWORD'),
}
export const CHANGEPASSWORD_ACTIONS = {
    ...actions('CHANGEPASSWORD'),
}
